function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/board/${view}.vue`
    );
}

const boardRoutes = [
  /* 정보마당 */

  // 공지사항
  {
    path: '/notice/list',
    name: 'noticeList',
    component: LoadView('noticeList'),
    meta: {
      category: ['정보마당', '공지사항'],
      isLnb: true,
    },
  },
  // 공지사항 - 상세
  {
    path: '/notice/view',
    name: 'noticeView',
    component: LoadView('noticeView'),
    meta: {
      category: ['정보마당', '공지사항'],
      isLnb: true,
    },
  },

  // 자주하는 질문
  {
    path: '/faq/view',
    name: 'faqView',
    component: LoadView('faqView'),
    meta: {
      category: ['정보마당', '자주하는 질문'],
      isLnb: true,
    },
  },

  // 묻고 답하기
  {
    path: '/customer',
    name: 'customer',
    component: LoadView('externalQnA'),
    beforeEnter: (to, from, next) => {
      const link = process.env.VUE_APP_QA_EXTERNAL_LINK;

      if (/Mobi/i.test(window.navigator.userAgent)) {
        location.href = link;
      } else {
        window.open(link, '_blank');
      }

      next(false);
    },
    meta: {
      category: ['정보마당', '묻고 답하기'],
    },
  },
];

export default boardRoutes;
